import { EMPTY_OBJECT } from 'commons-ui';
import { editPageName, listPageName } from '../utils/constants';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;
	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: editPageName,
					state: {
						rowData
					}
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: listPageName
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
